/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2023] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { View } from 'backbone.marionette';
import Syphon from 'backbone.syphon';

import tmplLogAProblemModalView from './LogAProblemModalView.hbs'

const LogAProblemModalView = View.extend({
  template: tmplLogAProblemModalView,

  className: 'log-a-problem-modal-view',

  ui: {
    saveBtn: '.saveBtn',
  },

  events: {
    'click @ui.saveBtn': 'onClickSave',
  },

  templateContext() {
    return {};
  },

  onRender() {},

  async onClickSave() {
    const formData = Syphon.serialize(this);
    this.triggerMethod('modal:close', formData);
  }
});

export default LogAProblemModalView;
